import React from "react";
import { Spinner } from "react-bootstrap";
import appVar from "../dataVar/appVar";

// Fallback de <Suspense> mientras se descarga el código de una pantalla (React.lazy en App.js).
const CargandoPantalla = () => (
    <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "40vh", gap: 10, color: appVar.gColorCorpLabel, fontSize: "0.9rem" }}
    >
        <Spinner animation="border" size="sm" style={{ color: appVar.gColorCorp }} />
        Cargando…
    </div>
);

export default CargandoPantalla;
